import { useEffect } from 'react';

import { pageLoadSuccess } from '@shared/utils-frontend/page-load-tracking';
import { getPageName } from '@shared/utils-universal/page-name';
import { trafficSource as getTrafficSource } from '@shared/utils-universal/traffic-source';
import { useLocation, useMatches } from 'react-router';

import type { MiniEventTracker as MiniEventTrackerType } from '@shared/types/frontend/mini-event-tracker';
import type { UserContext } from '@shared/types/user-context';
import type { Optional, StaySerialized } from '@shared/types/utils';

type Props = {
  userContext: UserContext;
  miniEventTracker: MiniEventTrackerType;
};

type RouteData = {
  props: {
    stay: Optional<StaySerialized>;
  };
};

export const usePageLoadTracking = ({
  miniEventTracker,
  userContext,
}: Props) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const matches = useMatches();

  useEffect(() => {
    const routeData = matches[matches.length - 1]?.data as
      | RouteData
      | undefined;
    const stay = routeData?.props?.stay;

    const source = searchParams.get('source');
    const trafficSource = getTrafficSource({ source });

    const {
      device,
      enableSEOVariantHotelsDetailsPage,
      pageType,
      userPreferences,
    } = userContext;
    const pageName = getPageName(pageType, enableSEOVariantHotelsDetailsPage);

    pageLoadSuccess({
      deviceInfo: device,
      isLoggedIn: userPreferences?.isLoggedIn ?? false,
      miniEventTracker,
      pageName,
      stay,
      trafficSource,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
